import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './OutreachPage.css';

const OutreachPage = () => {
  const { currentUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    // Check if user has permission
    if (!currentUser?.communityOutreach && currentUser?.userType !== 'admin') {
      navigate('/staff-dashboard');
    }
  }, [currentUser, navigate]);

  return (
    <div className="outreach-page">
      <div className="page-header">
        <h1>🤲 Community Outreach</h1>
        <p>Manage community outreach programs and initiatives</p>
      </div>

      <div className="outreach-content">
        <div className="info-card">
          <h2>Outreach Portal</h2>
          <p>This page is under development. It will include:</p>
          <ul>
            <li>Community outreach program management</li>
            <li>Event planning and coordination</li>
            <li>Community engagement tracking</li>
            <li>Volunteer coordination</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default OutreachPage;
